import { css } from 'lit';

export const style = css`
  .smsOptInError,
  #smsOptInAlert {
    margin-top: 1rem;
  }
`;
